// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesEventosCbba = importAll(
  require.context('../../assets/EventosCbba', true, /\.(png|jpe?g|svg)$/)
);